export default __webpack_public_path__ + "static/media/5.86d82d25.png";